import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/ui/visibility
const uiVisibilityApi = apiHandler("ui/visibility");

export default uiVisibilityApi;
